import forEach from "lodash/forEach";
import { Rect, Point } from "yfiles";
const FRAME_OUTER_OFFSET = 50;
export default (graphComponentRef, nodes) => {
    var _a;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.div.isConnected) || !nodes.length)
        return;
    let { maxX, maxY, x: minX, y: minY } = nodes[0].layout;
    forEach(nodes, (n, ind) => {
        if (ind === 0)
            return;
        if (n.layout.x < minX)
            minX = n.layout.x;
        if (n.layout.maxX > maxX)
            maxX = n.layout.maxX;
        if (n.layout.y < minY)
            minY = n.layout.y;
        if (n.layout.maxY > maxY)
            maxY = n.layout.maxY;
    });
    const bottomRightPoint = new Point(maxX + FRAME_OUTER_OFFSET, maxY + FRAME_OUTER_OFFSET);
    const topLeftPoint = new Point(minX - FRAME_OUTER_OFFSET, minY - FRAME_OUTER_OFFSET);
    const rect = new Rect(bottomRightPoint, topLeftPoint);
    graphComponentRef.current.zoomToAnimated(rect);
};
